<template>
    <div class="upgrade_rule">
        <titleBar class="title-bar" :title="title"></titleBar>
        <div v-for="(item, index) in content" :key="index">
            <p class="question">{{item.question}}</p>
            <p v-for="(answer, index) in item.answer" :key="index"  class="answer">{{answer}}</p>
        </div>
    </div>
</template>

<script>

import titleBar from "@/components/common/titleBar.vue";
import utils from "@/assets/js/utils";

export default {
  name: "",
  data() {
    return {
      content: [
        {
          question: "1.升级规则",
          answer: [
            "同步练会员和超级会员可通过开通小盒家⻓连续包月会员来升级权益，升级成功后获得免费会 员时间，可随时取消订阅包月会员，取消后免费时间可正常使用",
            "免费会员时间为您加至会员有效期中，将于付费时间到期后消耗"
          ]
        },
        {
          question: "2.时间计算规则",
          answer: [
            "免费会员时间=（语文、数学、英语三科同步练会员剩余时间之和）*0.85+（超级会员剩余时间）*1.14",
            "同步练时间换算比例：同步练会员30天价格/会员连续包月价格",
            "超级会员时间换算比例：超级会员30天价格/会员连续包月价格",
            "升级为会员后将清空您同步练会员及超级会员的时间"
          ]
        }
      ],
      title: "升级规则"
    };
  },
  components: {
    titleBar
  },
  methods: {},
  mounted(){
  const superMember = utils.getQueryString('superMember');  //超级会员
  const syncTest = utils.getQueryString('syncTest');  //同步练
  const freeDays = utils.getQueryString('freeDays');  //免费时间
  this.content.push({
    question: `3.您的免费时间${freeDays}天`,
    answer: [`${freeDays}天 = ${syncTest}天(同步练)*0.85 + ${superMember}天(超级会员)*1.14`]
  })
  }
};
</script>

<style lang="scss" scoped>
.upgrade_rule {
  width: 100%;
  min-height: 100vh;
  padding: 0.32rem;
  padding-top: 1.24rem;
  background: #fff;
  .title-bar {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      font-size: .34rem;
      color: #161616;
      box-shadow: 0px 1px 0px 0px 
  rgba(0, 0, 0, 0.06);
  }
  div {
    margin-bottom: 0.2rem;
    .question {
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #161616;
      margin-bottom: 0.18rem;
    }
    .answer {
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.45rem;
      letter-spacing: 0rem;
      color: #919294;
    }
  }
}
      /*iPhone X XS 2436x1125px at 458ppi */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .upgrade_rule {
        padding-top: 2.24rem;
    }
  }

  /*iPhone XR 1792x828px at 326ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .upgrade_rule {
        padding-top: 2.24rem;
    }
  }

  /* iPhone XS Max 2688x1242px at 458ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .upgrade_rule {
        padding-top: 2.24rem;
    }
  } 
</style>